module.exports = __webpack_public_path__ + "img/call-to-action.55c147f2.svg";